import React, { useEffect, useRef, useState } from "react";
import { message, Table } from "antd";
import { IBillCashDetail } from "../../../bill/BillTypes";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { AppDrawer } from "@/components/YhDrawer";
import { tradeTypeDs } from "@/types/FmsDs";
import { useWriteoffModel } from './writeoffModel'
import { useDetailModel } from "../detailModel";
import { ColumnsType } from "antd/lib/table";
import { accountService } from "../../AccountService";
import { useLockFn } from "ahooks";
import useGlobalModel from "@/model/globalModel";

export const WriteoffDrawer = () => {
  const {
    selectedData,
    openDrawerVisible,
    setOpenDrawerVisible,
    resetSearchParam,
    onClear,
  } = useWriteoffModel(model => [model.openDrawerVisible]);

  const { user } = useGlobalModel()
  useEffect(() => {
    if (openDrawerVisible) {
    }
  }, [openDrawerVisible])

  const {
    orgDs,
    beDs,
  } = useDetailModel(model => [
    model.orgDs,
    model.beDs,
  ])
  const formRef = useRef<IYhFormRef>();


  const formConfig: IYhForm = {
    labelCol: { span: 6 },
    disabled: false,
    formValues: { ...selectedData },
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "核销单号",
        fieldName: "code",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "核销账户",
        fieldName: "accountName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "账户编码",
        fieldName: "accountCode",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "核销单位",
        fieldName: "uniName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "核销实体",
        fieldName: "beName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "对方账户",
        fieldName: "adverseName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "对方单位",
        fieldName: "adverseUnitName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "对方实体",
        fieldName: "adverseBeName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "核销金额",
        fieldName: "writeoffAmount",
        disable: true,
        span: 24,
      },

      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "申请说明",
        fieldName: "note",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "审核",
        fieldName: "writeoffStatus",
        ds: [
          {
            label: "通过",
            value: 1
          },
          {
            label: "驳回",
            value: 0
          },
        ],
        span: 24,
      },
    ]
  };

  const onOk = useLockFn(async () => {
    try {
      let formData = await formRef.current?.validateFields();
      if (formData) {

        let data = {};
        if (selectedData?.status === 3) {
          data = {
            code: selectedData?.code,
            status: formData.writeoffStatus === 1 ? 5 : 4,
            financeAffirmUser: user.userName
          }
        }
        if (selectedData?.status === 5) {
          data = {
            code: selectedData?.code,
            status: formData.writeoffStatus === 1 ? 7 : 6,
            financeAuditUser: user.userName
          }
        }
        if (selectedData?.status === 7) {
          data = {
            code: selectedData?.code,
            status: formData.writeoffStatus === 1 ? 8 : 9,
            endAuditUser: user.userName
          }
        }
        let insertRet = await accountService.allotWriteoff(data);
        if (insertRet.success) {
          message.success("核销成功!");
          onClear();
          setOpenDrawerVisible(false);
        } else {
          message.error("核销失败!" + insertRet.retMsg);
        }
      }
    } catch (e) {
      console.log("数据校验失败");
    }
  });
  const onCancel = () => {
    setOpenDrawerVisible(false);
  };
  return (
    <AppDrawer
      {...{
        title: "现金收款",
        visible: openDrawerVisible,
        showFooter: true,
        onCancel,
        width: 500,
        onOk,
      }}
    >
      <YhForm formRef={formRef} {...formConfig} />
    </AppDrawer>
  )
}
